export enum MessageTypes {
  RequiredField = 'RequiredField',
  IncomparablePassword = 'IncomparablePassword',
  WrongEmail = 'WrongEmail',
  LogoAlt = 'LogoAlt',
  PasswordLength = 'PasswordLength',
}

export const messages = {
  [MessageTypes.RequiredField]: 'This field is required',
  [MessageTypes.IncomparablePassword]: 'Passwords do not match',
  [MessageTypes.WrongEmail]: 'Incorrect email address',
  [MessageTypes.PasswordLength]:
    'Password should be at least 8 characters length',
};
